export default __webpack_public_path__ + "static/media/tete90.6f74dd4a.png";